export const FETCH_STATES_REQUEST = 'FETCH_STATES_REQUEST';
export const FETCH_STATES_SUCCESS = 'FETCH_STATES_SUCCESS';
export const FETCH_STATES_FAILURE = 'FETCH_STATES_FAILURE';

export const CREATE_STATE_REQUEST = 'CREATE_STATE_REQUEST';
export const CREATE_STATE_SUCCESS = 'CREATE_STATE_SUCCESS';
export const CREATE_STATE_FAILURE = 'CREATE_STATE_FAILURE';

export const UPDATE_STATE_REQUEST = 'UPDATE_STATE_REQUEST';
export const UPDATE_STATE_SUCCESS = 'UPDATE_STATE_SUCCESS';
export const UPDATE_STATE_FAILURE = 'UPDATE_STATE_FAILURE';

export const DELETE_STATE_REQUEST = 'DELETE_STATE_REQUEST';
export const DELETE_STATE_SUCCESS = 'DELETE_STATE_SUCCESS';
export const DELETE_STATE_FAILURE = 'DELETE_STATE_FAILURE';

export const fetchStatesRequest  = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
      type:FETCH_STATES_REQUEST,
      payload: { projectId, page, limit, search },
      
    };
    
  }; 
export const fetchStatesSuccess = (states) => ({ type: FETCH_STATES_SUCCESS, payload: states });
export const fetchStatesFailure = (error) => ({ type: FETCH_STATES_FAILURE, payload: error });

export const createStateRequest = (data) => ({ type: CREATE_STATE_REQUEST, payload: data });
export const createStateSuccess = (state) => ({ type: CREATE_STATE_SUCCESS, payload: state });
export const createStateFailure = (error) => ({ type: CREATE_STATE_FAILURE, payload: error });

export const updateStateRequest = (id, data,projectId) => ({ type: UPDATE_STATE_REQUEST, payload: { id, data ,projectId} });
export const updateStateSuccess = (state) => ({ type: UPDATE_STATE_SUCCESS, payload: state });
export const updateStateFailure = (error) => ({ type: UPDATE_STATE_FAILURE, payload: error });

export const deleteStateRequest = (id, projectId) => ({ type: DELETE_STATE_REQUEST, payload: { id, projectId } });
export const deleteStateSuccess = (id) => ({ type: DELETE_STATE_SUCCESS, payload: id });
export const deleteStateFailure = (error) => ({ type: DELETE_STATE_FAILURE, payload: error });
